import { MainLayout } from 'shared/ui/layout/main';

import { DiscountsTabs } from '../tabs';

export function DiscountsLayout() {
  return <MainLayout tabs={<DiscountsTabs />} />;
}
